import { Route, useParams, useNavigate, useLocation } from 'react-router-dom';
import { pages } from '../../../utils/common';
import StudentsView from './students.view';
import { ProtectedRoute } from '../../../components/rbac/ProtectedRoute';
import StudentDetailsView from './subviews/studentDetails/studentDetails.view';
import { FC, useEffect } from 'react';

const StudentDetailsRedirect: FC = () => {
  const { studentId } = useParams<{ studentId: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (studentId) {
      const targetPath = `${pages.students.path}/${studentId}/details/profile`;
      // Only navigate if we're not already on the target path
      if (location.pathname !== targetPath && !location.pathname.includes('/details/profile')) {
        navigate(targetPath, {
          replace: true,
        });
      }
    }
  }, [studentId, navigate, location.pathname]);

  return null;
};

const useStudentsRoutes = () => {
  const studentsComponent = (
    <ProtectedRoute module="students" checkAnySubmodule>
      <StudentsView />
    </ProtectedRoute>
  );

  return (
    <Route path={pages.students.path} element={studentsComponent}>
      <Route
        index
        element={studentsComponent}
      />
      <Route
        path=":studentId/details/:tab"
        element={
          <ProtectedRoute module="students" checkAnySubmodule>
            <StudentDetailsView />
          </ProtectedRoute>
        }
      />
      <Route
        path=":studentId/details"
        element={<StudentDetailsRedirect />}
      />
      <Route
        path=":studentSubRouteId"
        element={studentsComponent}
      />
    </Route>
  );
};

export default useStudentsRoutes;
